import DataTable from 'react-data-table-component';
import { Button, Badge } from 'react-bootstrap';
import moment from 'moment';

const WhatsAppManagerDataTable = ({ data, loading, onEdit, onDelete, onActivate }) => {

  const getManagerTypeBadge = (type) => {
    const variants = {
      'basic': 'primary',
      'upgraded': 'success'
    };
    return (
      <Badge bg={variants[type] || 'secondary'}>
        {type?.toUpperCase() || 'UNKNOWN'}
      </Badge>
    );
  };

  const getStatusBadge = (isActive) => {
    return (
      <Badge bg={isActive ? 'success' : 'danger'}>
        {isActive ? 'ACTIVE' : 'INACTIVE'}
      </Badge>
    );
  };

  const getBooleanBadge = (value) => {
    return (
      <Badge bg={value ? 'success' : 'secondary'}>
        {value ? 'YES' : 'NO'}
      </Badge>
    );
  };

  const dateOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  const sortDate = (rowA, rowB) => {
    const dateA = new Date(rowA.created_at);
    const dateB = new Date(rowB.created_at);
    if (dateA > dateB) {
      return 1;
    }
    return -1;
  };

  const sortID = (rowA, rowB) => {
    const idA = parseInt(rowA.user_id || rowA.id);
    const idB = parseInt(rowB.user_id || rowB.id);
    if (idA > idB) {
      return 1;
    }
    return -1;
  };

  const columns = [
    {
      name: 'ID',
      sortable: true,
      selector: (row) => row.user_id || row.id,
      sortFunction: sortID,
      width: '80px'
    },
    {
      name: 'Name',
      sortable: true,
      selector: (row) => row.name || 'N/A',
    },
    {
      name: 'Email',
      sortable: true,
      selector: (row) => row.email || 'N/A',
    },
    {
      name: 'Manager Type',
      sortable: true,
      selector: (row) => row.manager_type || 'N/A',
      cell: (row) => getManagerTypeBadge(row.manager_type),
    },
    {
      name: 'Max Agents',
      sortable: true,
      selector: (row) => row.max_agents || 0,
      cell: (row) => (
        <span>
          {row.manager_type === 'upgraded' ? 'Unlimited' : (row.max_agents || 5)}
        </span>
      ),
    },
    {
      name: 'Current Agents',
      sortable: true,
      selector: (row) => row.current_agents_count || 0,
      cell: (row) => (
        <Badge bg="info">
          {row.current_agents_count || 0}
        </Badge>
      ),
    },
    {
      name: 'Status',
      sortable: true,
      selector: (row) => row.manager_active,
      cell: (row) => getStatusBadge(row.manager_active),
    },
    {
      name: 'Transfer Conversations',
      sortable: true,
      selector: (row) => row.can_transfer_conversations,
      cell: (row) => getBooleanBadge(row.can_transfer_conversations),
    },
    {
      name: 'Advanced Analytics',
      sortable: true,
      selector: (row) => row.can_view_advanced_analytics,
      cell: (row) => getBooleanBadge(row.can_view_advanced_analytics),
    },
    {
      name: 'Created At',
      sortable: true,
      selector: (row) => row.created_at,
      sortFunction: sortDate,
      cell: (row) => (
        <span>
          {row.created_at
            ? moment(row.created_at).format('MMM DD, YYYY HH:mm')
            : 'N/A'
          }
        </span>
      ),
    },
    {
      name: 'Actions',
      minWidth: '100px',
      cell: (row) => (
        <div className="d-flex flex-column justify-content-center align-items-center gap-1">
          <Button
            variant="primary"
            size="sm"
            onClick={() => onEdit(row)}
            style={{ width: 70, fontSize: '12px' }}
          >
            Edit
          </Button>
          {!row.manager_active ? (
            <Button
              variant="success"
              size="sm"
              onClick={() => onActivate(row)}
              style={{ width: 70, fontSize: '12px' }}
            >
              Activate
            </Button>
          ) : (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => onDelete(row)}
              style={{ width: 70, fontSize: '12px' }}
            >
              Remove
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={data || []}
        progressPending={loading}
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
        }}
        pagination
        noDataComponent={
          <div className="text-center p-4">
            <p>No WhatsApp managers found.</p>
          </div>
        }
      />
    </>
  );
};

export default WhatsAppManagerDataTable;
